export const COMMENT_MIN_LENGTH = 25;
export const COMMENT_MAX_LENGTH = 500;

export const CHANGE_DATE_REQUEST_STATUS = {
  PENDING_ADMIN_APPROVAL: 1,
  APPROVED: 2,
  DECLINED: 3,
  PENDING_FDA_APPROVAL: 4
};

export const CHANGE_DATE_REQUEST_ACTION_TYPE = {
  USER_ACTION: 1,
  SYSTEM_ACTION: 2
};
